import { render, staticRenderFns } from "./list-wasiat.vue?vue&type=template&id=274840eb&"
import script from "./list-wasiat.vue?vue&type=script&lang=js&"
export * from "./list-wasiat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports